export enum UnitType {
  Units = 'Units',
  Volume = 'Volume',
  Weight = 'Weight',
}

export enum TagType {
  GENERAL = 'GENERAL',
  DIETARY = 'DIETARY',
}

export enum LOCALE {
  ENGLISH_US = 'ENGLISH_US',
  HINDI = 'HINDI',
  DUTCH = 'DUTCH',
  CHINESE = 'CHINESE',
  SPANISH_SPAIN = 'SPANISH_SPAIN',
}

export const LANGUAGE_LOCALE_MAP = {
  [LOCALE.ENGLISH_US]: 'en-US',
  [LOCALE.HINDI]: 'hi-IN',
  [LOCALE.SPANISH_SPAIN]: 'es-ES',
  [LOCALE.DUTCH]: 'de-DE',
  [LOCALE.CHINESE]: 'zh-CN',
};

export enum ProductUpdateAction {
  GENERAL = 'GENERAL',

  // INVENTORY will ignore update cached of catalogues
  INVENTORY = 'INVENTORY',
}

export enum ProductAllergens {
  CELERY = 'Celery',
  CEREAL_WITH_GLUTEN = 'Cereals with gluten',
  CRUSTACEANS = 'Crustaceans',
  EGGS = 'Eggs',
  FISH = 'Fish',
  GARLIC = 'Garlic',
  GINGER = 'Ginger',
  GLUTEN = 'Gluten',
  GLUTEN_NUTS = 'Gluten Nuts',
  LEGUME = 'Legumes',
  LUPIN = 'Lupin',
  MANGO = 'Mango',
  MILK = 'Milk',
  MOLLUSCS = 'Molluscs',
  MUSTARD = 'Mustard',
  ONION = 'Onion',
  PEANUTS = 'Peanuts',
  SESAME_SEEDS = 'Sesame seeds',
  SOYBEANS = 'Soybeans',
  SULPHUR_DIOXIDE_SULPHITES = 'Sulphur dioxide & sulphites',
  TREE_NUTS = 'Tree nuts',
}

export enum NutrientName {
  ENERGY = 'Energy',
  FAT = 'Fat',
  SATURATES = 'Saturates',
  CARBOHYDRATE = 'Carbohydrate',
  SUGAR = 'Sugar',
  PROTEIN = 'Protein',
  SALT = 'Salt',
  FIBRE = 'Fibre',
}

export enum NutrientUnit {
  KCAL = 'kcal',
  CAL = 'cal',
  KJ = 'kJ',
  G = 'g',
}

export enum ComboType {
  REGULAR = 'REGULAR',
  PORTION = 'PORTION',
}

export enum ComboPricingRule {
  FIXED = 'FIXED',
  PRO_RATA = 'PRO_RATA',
  HIGHEST = 'HIGHEST',
}

export enum AttributeType {
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}
